import { captureMessage, setContext } from "@sentry/nextjs";

export type FormValidationErrorEvent = {
  formName: string;
  errorType: string;
  fields?: string[];
  fieldMessages?: Record<string, string>;
  context?: Record<string, string | undefined>;
};

export function trackFormValidationError(event: FormValidationErrorEvent): void {
  const { context, ...extra } = event;
  const properties = {
    formName: event.formName,
    errorType: event.errorType,
    ...(event.fields ? { fields: event.fields } : {}),
    ...Object.fromEntries(
      Object.entries(event.fieldMessages ?? {}).map(([field, message]) => [
        `field_${field}`,
        message,
      ]),
    ),
  };
  const capture = () => {
    captureMessage(`form.validation: ${event.formName}: ${event.errorType}`, {
      level: "log",
      extra: { ...extra, ...context },
    });
  };
  const logRocket = globalThis.window?.LogRocket;

  if (!logRocket) {
    capture();
    return;
  }

  try {
    logRocket.track("form_validation_error", properties);
    logRocket.getSessionURL((sessionURL) => {
      setContext("logRocket", { sessionURL });
      capture();
    });
  } catch {
    capture();
  }
}
